import { gql } from "@apollo/client";

export const CREATE_WORK_ORDER_MUTATION = gql`
  mutation CreateWorkOrder($input: CreateWorkOrderInput!) {
    createWorkOrder(input: $input) {
     id
        title
        description
        severity
    }
  }
`;

// Update Work Order Mutation

export const UPDATE_WORK_ORDER_MUTATION = gql`
  mutation UpdateWorkOrder($input: UpdateWorkOrderInput!) {
    updateWorkOrder(input: $input) {
      id
      title
    }
  }
`;

// Delete Work Order Mutation

export const DELETE_WORK_ORDER_MUTATION = gql`
  mutation DeleteWorkOrder($id: ID!) {
  deleteWorkOrder(id: $id)
}
`;

// Generate Document (AI) Mutation
